// Notifications: the priority actions card of the Desk Dashboard
// (`wealth.platform.notifications`, ADR-0027). The server gives the priority
// actions under this feature.
import { lazy } from 'react';
import { defineWebFeature } from '@/features/kit';
import {
    PRIORITY_ACTIONS_CARD,
    priorityActionsCardCount,
} from '@/components/shell/priority-actions-card';

const PriorityActionsCard = lazy(() =>
    import('./notifications.slots').then((m) => ({ default: m.PriorityActionsCard })),
);

export default defineWebFeature({
    id: 'wealth.platform.notifications',
    slots: {
        'desk.dashboard.cards': [
            {
                ...PRIORITY_ACTIONS_CARD,
                order: 5,
                // The page reads the count once (`usePriorityActionCount`). With
                // no open action the card shows its header only.
                count: (ctx) => priorityActionsCardCount(ctx.priorityActionCount),
                Component: PriorityActionsCard,
            },
        ],
    },
});
